import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { SignOutService } from "@service/sign-out.service";

export const useSignOut = () => {
  const dispatch = useDispatch();

  const signOut = useCallback(async () => {
    await SignOutService.instance.signOut(dispatch);
  }, [dispatch]);

  return signOut;
};
